import React from 'react'
import Image from "../components/Image";
import {Chip, Grid} from "@material-ui/core";
import {graphql, Link, useStaticQuery} from "gatsby";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import {germanDateToEnglishDate} from "./utils";
import * as moment from "moment";

export default function EventsOverview({categories, types}) {

    const data = useStaticQuery(graphql`
        query {
            allWordpressWpEvent {
                edges {
                    node {
                        id
                        slug
                        acf {
                            event {
                                category
                                level
                                instructor
                                shortdescription
                                longdescription
                                enddate
                                location {
                                    location
                                    street
                                    postleitzahl
                                }
                                price
                                title
                                startdate
                                type
                                image {
                                   alt_text
                                        title
                                        description
                                        localFile {
                                        childImageSharp {
                                            id
                                            fluid {
                                                base64
                                                tracedSVG
                                                aspectRatio
                                                src
                                                srcSet
                                                srcWebp
                                                srcSetWebp
                                                originalName
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const filteredEdges = data.allWordpressWpEvent.edges
        .filter((edge, index) =>
            (!categories || categories.includes(edge.node.acf.event.category)) && (!types  || types.includes(edge.node.acf.event.type))
        );

    const newEvents = filteredEdges.filter((edge) => {
        const event = edge.node.acf.event;

        const today = moment();
        let compareDate;
        if(event.enddate) {
            compareDate = moment(event.enddate, 'DD/MM/YYYY');
        } else if(event.startdate){
            compareDate = moment(event.startdate, 'DD/MM/YYYY');
        } else {
            // no dates provided
            return true;
        }
        return compareDate.isSameOrAfter(today);
    });

    const sortedEdges = newEvents.sort((a, b) => {
        const aDate = germanDateToEnglishDate(a.node.acf.event.startdate);
        const bDate = germanDateToEnglishDate(b.node.acf.event.startdate);
        return (aDate >= bDate) ? 1 : -1;
    });

    const events = sortedEdges.map((edge, index) =>
        <Grid item lg={4} style={{marginBottom: '2em'}} key={`event_becometrainer_relaqua_${index}`}>
            <Link to={`/event/${edge.node.slug}`}>
                <Card className="card">
                    {
                        edge.node.acf.event && edge.node.acf.event.image && edge.node.acf.event.image.localFile &&
                        <Image image={edge.node.acf.event.image}/>
                    }
                    <CardContent style={{padding: '2em'}}>
                        <h2>
                            {edge.node.acf.event.title}
                        </h2>
                        <div style={{marginBottom: '1em'}}>
                            {edge.node.acf.event.level && <Chip style={{marginRight: '0.5em'}} color="secondary" label={edge.node.acf.event.level}/>}
                            {edge.node.acf.event.instructor && <Chip label={`Instructor: ${edge.node.acf.event.instructor}`}/>}
                        </div>
                        <div>
                            {edge.node.acf.event.shortdescription}
                        </div>
                        <div style={{marginTop: '1em'}}>
                            <strong>Datum: </strong>
                            {
                                edge.node.acf.event.enddate ?
                                    <span> {edge.node.acf.event.startdate} - {edge.node.acf.event.enddate}</span>
                                    :
                                    <span>{edge.node.acf.event.startdate}</span>
                            }
                        </div>
                        {edge.node.acf.event.location && edge.node.acf.event.location.location && <div><strong>Ort: </strong> {edge.node.acf.event.location.location}</div>}
                        {edge.node.acf.event.price && <div><strong>Preis: </strong> {edge.node.acf.event.price}</div>}
                        <div><strong>Kategorie: </strong>{edge.node.acf.event.category}</div>
                    </CardContent>
                </Card>
            </Link>
        </Grid>)

    return (
        <Grid container spacing={2}>
            {
                events.length ?  events : <div>Keine Events vorhanden</div>
            }
        </Grid>
    )
}
